<template>
  <div class="salesmandaili3Page">
    <mu-appbar title="我的辖区代理">
        <div slot="right" class="title-text" @click="open('top')" >
          <p>筛选</p>    
          <mu-popup position="top" popupClass="salesmandaili3Page-popup" :open="topPopup" @close="close('top')">
            <mu-content-block>
              <div class="popuptitle delivery-type-order">
                  <mu-row class="gutter">
                    <mu-col width="100" tablet="50" desktop="33">
                    <mu-text-field label="省市区" helpText="请选择省市区"  labelFloat fullWidth v-model="address" @focus="openBottomSheet" />
                    <mu-bottom-sheet :open="bottomSheet" @close="closeBottomSheet">            
                        <mu-picker :slots="addressSlots" :visible-item-count="5" @change="addressChange" :values="address" @itemClick="closeBottomSheet"/>
                    </mu-bottom-sheet>
                    </mu-col>
                </mu-row>   
                <mu-row  class="btn" style="margin-top: 40px;">
                    <mu-col width="100" tablet="50" desktop="50" class="btn-div">          
                        <mu-raised-button style="height:50px;" label="确 定" class="submit" @click="areaSearch" primary fullWidth />
                    </mu-col>
                </mu-row>
              </div>              
            </mu-content-block>
          </mu-popup>      
        </div>
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
    </mu-appbar>
      <mu-list >
          <mu-list-item class="proList" v-for="sItem in salesmanList" :key="sItem.minnerbm">
              <div class="mu-item-title">
                  <div class="dd1">
                  <p class="name">{{sItem.userbm}}</p><p class="date">{{sItem.address}}</p>
                  </div>
                  <div class="dd2">
                      <p class="date">{{sItem.shsjname}}</p>
                      <p class="type">{{sItem.catename}}</p>
                  </div>
                  </div>
          </mu-list-item>
      </mu-list>
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>
<script>
var address = {
  '北京': {'北京':['北京']},
  '湖北': {'武汉':['武昌区','汉阳区','青山区'], '黄石':['黄石']},
  '台湾': {'台北市':['台北市']}
}
export default {
  data () {
    return {
        topPopup: false,
        titleText: this.$route.query.id?'编辑收货地址':'添加收货地址',
        loaded:true,
        password:"",
        bottomSheet: false,
        selectAddress:'',      
        addressSlots: [
        {
          width: '100%',
          textAlign: 'right',
          values: ['全部']
        }, {
          width: '100%',
          textAlign: 'center',
          values: ['全部']
        }, {
          width: '100%',
          textAlign: 'left',
          values: ['全部']
        }
      ],
      addressProvince: '全部',
      addressCity: '全部',
      addressArea: '全部',
      searchInfo:{
        userbs : this.$route.query.userbs,
        Province : '全部',
        City:'全部',
        Area:'全部'
      },
      salesmanList:[]
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()   
    this.getAreaList()
    this.getSalesmanList()
  },
  methods: {
    GoHistory(){
    this.$router.goBack()
    },
    open (position) {
      this[position + 'Popup'] = true
      this.titleIcon = "fa fa-angle-up";
    },
    close (position) {
      this[position + 'Popup'] = false
      this.titleIcon = "fa fa-angle-down";
    },
    getAreaList(){
      var ths = this;   
      ths.$post(
        "/Salesman/BaseServer/GetAreaAllListGroup"
      ).then(function(res) {
        if(!res.IsSuccess){
        }else{     
          address= JSON.parse(res.Data) 
          ths.addressSlots[0].values = Object.keys(address)             
        }
      });
    },
    addressChange (value, index) {
      switch (index) {
        case 0:
          this.addressProvince = value
          var cirtyList = address[value]
          var keys = Object.keys(cirtyList)          
          this.addressSlots[1].values = keys
          this.addressCity = keys[0]
          
          var areaList = address[this.addressProvince][this.addressCity]        
          this.addressSlots[2].values = areaList
          this.addressArea = areaList[0]
          break
        case 1:      
          this.addressCity = value
          var arr1 = address[this.addressProvince][value]          
          this.addressSlots[2].values = arr1
          this.addressArea = arr1[0]
          break
        case 2:
          this.addressArea = value
          break
      }
      this.address = [this.addressProvince, this.addressCity, this.addressArea]
      this.searchInfo.Province = this.addressProvince
      this.searchInfo.City = this.addressCity
      this.searchInfo.Area = this.addressArea
    },
    closeBottomSheet () {
      this.bottomSheet = false
    },
    openBottomSheet () {
      this.bottomSheet = true
    },
    areaSearch(){
        this.close('top')
        this.getSalesmanList()
    },
    getSalesmanList:function(){
      var ths = this;   
      ths.$post(
        "/Salesman/SalesmanServer/GetMyXiaQuMemberStream",
        this.searchInfo
      ).then(function(res) {
        ths.$refs.XRtoast.hide()
        ths.loaded = false
        if(!res.IsSuccess){
          ths.salesmanList=[]
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{       
          ths.salesmanList= res.Data.List
          ths.$refs.XRPageTip.initTip()
        }
      });
    },
    goBack(){
      this.$router.goBack()
    }
  }
}
</script>
<style>
    body .salesmandaili3Page{
        background: #fff;
    }
    .salesmandaili3Page .mu-appbar{
    position: fixed;
    top: 0;
    z-index: 20180101;
    }
    .salesmandaili3Page .mu-list{
        top: 56px;
    }
    .salesmandaili3Page .mu-appbar-title {
        font-size: 16px;
    }
    .salesmandaili3Page .right .title-text{
        font-size: 16px;
    }
    .salesmandaili3Page .mu-appbar{
    position: fixed;
    top: 0;
    z-index: 20180101;
    }
    .salesmandaili3Page .mu-list{
        top: 56px;
    }
    .salesmandaili3Page .mu-appbar-title {
        font-size: 16px;
    }
    .salesmandaili3Page .right .title-text{
        font-size: 16px;
    }
    .salesmandaili3Page-popup {
        width: 100%;
        top:56px;
        height: 250px;
        z-index: 1;
        padding: 20px 0;
    }
    .salesmandaili3Page .salesmandaili3Page-popup .popuptitle .title{
        overflow: hidden;
    }
    .salesmandaili3Page .salesmandaili3Page-popup .popuptitle .title .text{
        float: left; 
        width:20%;
        text-align: center;
        line-height: 24px;
        color:#ccc;
    }
    .salesmandaili3Page .salesmandaili3Page-popup .popuptitle .title .line{
        float: left; 
        height: 1px;
        background:#eee;
        width: 80%;
        border: none;
        margin-top: 10px;
    }
    .salesmandaili3Page .mu-list{
      margin-top: 10px;
    }
    .salesmandaili3Page .dd1
    {
        float:left;
        width:60%;
        text-align:left;
        font-size:14px;
    }
    .salesmandaili3Page .dd1 span{
          color: #666;
        margin-left: 5px;
    }
        
    .salesmandaili3Page .dd1 .date { color: #999; font-size:12px;}
    .salesmandaili3Page .dd1 .name {  font-size:14px;}
    .salesmandaili3Page .dd2
    {
        font-size: 14px;
        float: right;
        width: 30%;
        text-align: center;
        padding-left: 2%;
    }
   body .salesmandaili3Page .dd2 .type { color: red; font-size:14px;}
    .salesmandaili3Page .mu-item{
        border-bottom: 1px solid #f5f5f5;
    }
</style>


// WEBPACK FOOTER //
// src/pages/salesman/mydaililist.vue